export const ADDITIONAL_COURSE_ID = 4
